var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideoPlaylist({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-inline--fa fa-fw",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5.5C3.5 4.11929 4.61929 3 6 3H11.6667C13.0474 3 14.1667 4.11929 14.1667 5.5V11.1667C14.1667 12.5474 13.0474 13.6667 11.6667 13.6667H6C4.61929 13.6667 3.5 12.5474 3.5 11.1667V5.5Z",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5.83334V14.5C18 16.1569 16.6569 17.5 15 17.5H6.33337",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.99999V6.66666L10.619 8.33332L8 9.99999Z",
    fill: "currentColor",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68773 8.33332L8.5 9.08915V7.57749L9.68773 8.33332Z",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlaylist);
export default "data:image/svg+xml;base64,PHN2ZyBjbGFzc05hbWU9InN2Zy1pbmxpbmUtLWZhIGZhLWZ3IiB2aWV3Qm94PSIwIDAgMjEgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0zLjUgNS41QzMuNSA0LjExOTI5IDQuNjE5MjkgMyA2IDNIMTEuNjY2N0MxMy4wNDc0IDMgMTQuMTY2NyA0LjExOTI5IDE0LjE2NjcgNS41VjExLjE2NjdDMTQuMTY2NyAxMi41NDc0IDEzLjA0NzQgMTMuNjY2NyAxMS42NjY3IDEzLjY2NjdINkM0LjYxOTI5IDEzLjY2NjcgMy41IDEyLjU0NzQgMy41IDExLjE2NjdWNS41WiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1vcGFjaXR5PSIwLjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTggNS44MzMzNFYxNC41QzE4IDE2LjE1NjkgMTYuNjU2OSAxNy41IDE1IDE3LjVINi4zMzMzNyIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1vcGFjaXR5PSIwLjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOCA5Ljk5OTk5VjYuNjY2NjZMMTAuNjE5IDguMzMzMzJMOCA5Ljk5OTk5WiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLW9wYWNpdHk9IjAuNyIvPgo8cGF0aCBkPSJNOS42ODc3MyA4LjMzMzMyTDguNSA5LjA4OTE1VjcuNTc3NDlMOS42ODc3MyA4LjMzMzMyWiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1vcGFjaXR5PSIwLjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };